import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Intro } from '../components/Intro';
import { DifficultSituation } from '../components/DifficultSituation';
import { Services } from '../components/Services';
import { LoveGuidance } from '../components/LoveGuidance';
import { Testimonials } from '../components/Testimonials';
import { Trajectory } from '../components/Trajectory';
import { MaestroJohn } from '../components/MaestroJohn';
import { VideoCall } from '../components/VideoCall';
import { FinalCTA } from '../components/FinalCTA';
import { Contact } from '../components/Contact';
import { Policies } from '../components/Policies';
import { Footer } from '../components/Footer';
import { MobileActionBar } from '../components/MobileActionBar';
import { useTawkTo } from '../hooks/useTawkTo';
import { useViewportMeta } from '../hooks/useViewportMeta';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { useGoogleTagManager } from '../hooks/useGoogleTagManager';
interface LandingProps {
  lockup: string;
  showTestimonials: boolean;
  freeInitialConsultation: boolean;
}
export function Landing({
  lockup,
  showTestimonials,
  freeInitialConsultation
}: LandingProps) {
  useDocumentMeta();
  useViewportMeta();
  useGoogleTagManager();
  useTawkTo();
  return <div className="min-h-full w-full overflow-x-hidden bg-ink font-sans" data-id="element-246" data-mp="3kgygnonbfokq">
      <Header lockup={lockup} data-id="element-247" data-mp="l11lb1g60ttz" />
      <main data-id="element-248" data-mp="l005yks49l6g">
        <MobileActionBar data-id="element-249" data-mp="kzqcgn7v4vw0" />
        <Hero lockup={lockup} data-id="element-250" data-mp="gywpbw28vl46" />
        <Intro data-id="element-251" data-mp="gyodm7huyluk" />
        <DifficultSituation data-id="element-252" data-mp="h07sbtnv8ou8" />
        <Services data-id="element-253" data-mp="h112l4m19wh4" />
        <LoveGuidance data-id="element-254" data-mp="c87z0k2awu6m" />
        {showTestimonials ? <Testimonials data-id="element-255" data-mp="c6ww0mgojqgk" /> : null}
        <Trajectory data-id="element-256" data-mp="c63k772v6ark" />
        <MaestroJohn data-id="element-257" data-mp="794wp7dph22c" />
        <VideoCall data-id="element-258" data-mp="79wr4evkgtr1" />
        <FinalCTA freeInitialConsultation={freeInitialConsultation} data-id="element-259" data-mp="78bwyqd5zctp" />
        <Contact data-id="element-260" data-mp="14p0vaa2wnwyc" />
        <Policies data-id="element-261" data-mp="14pkb9l8zwb9q" />
      </main>
      <Footer lockup={lockup} data-id="element-262" data-mp="14ptves7czo7i" />
    </div>;
}